import styled, { css } from 'styled-components';
import { pxToRem } from '@anwb/style-utilities';
import { Select } from '../../select';
/**
 * Caption container
 */
export const captionContainerStyles = ({ theme }) => css `
	padding: ${pxToRem(theme.spacing['200'])} ${pxToRem(theme.spacing['100'])} 0
		${pxToRem(theme.spacing['100'])};
	display: flex;
	flex-direction: row;
	gap: ${pxToRem(theme.spacing['200'])};
`;
export const CaptionContainer = styled.div `
	${captionContainerStyles}
`;
/**
 * Caption month button
 */
export const captionMonthButtonStyles = ({ theme }) => css `
	// override core ui
	&& {
		border-width: 0;
		padding: 0;
		width: auto;
		background-color: transparent;
		color: ${theme.colors.highlight.iconInteractive};

		&:focus,
		&:hover {
			color: ${theme.colors.highlight.iconHover};
		}
	}
`;
export const CaptionMonthButton = styled.button `
	${captionMonthButtonStyles}
`;
/**
 * Caption select
 */
export const captionSelectStyles = () => css `
	flex: auto;
	width: auto;
`;
export const CaptionSelect = styled(Select) `
	${captionSelectStyles}
`;
//# sourceMappingURL=caption.styled.js.map